import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverFooter,
  Button,
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  HStack,
  Text,
  Image,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import { useState } from "react";
import { savePromptApi } from "../../../allApi/api";
import { v4 as uuidv4 } from "uuid";
import { useCustomTost } from "../../../utiils/useCustomTost";
import { useDispatch } from "react-redux";
import { savePromptDataFun } from "../../../redux/reducer/promptTestingReduce";

const MyPopover = ({ setFormData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const toast = useCustomTost();

  const [saveFormData, setSaveFormData] = useState({ name: "", desc: "" });

  const handleChange = (e) => {
    setSaveFormData({ ...saveFormData, [e.target.name]: e.target.value });
  };

  const handleSubmitTestPrompt = async () => {
    if (saveFormData.name == "" || !saveFormData.name) {
      setError("test prompt is require");
      return;
    }
    setLoading(true);
    const proptId = localStorage.getItem("propt_id");
    try {
      const res = await savePromptApi({
        ...saveFormData,
        session_id: proptId,
      });

      if (res?.status !== "success") {
        toast("An error occurred.", res?.message, "error");
        throw new Error(res?.message || "Error Occured");
      } else if (res?.status == "success") {
        dispatch(savePromptDataFun(proptId));

        toast("Success", res?.message, "success");
      }
    } catch (error) {
      toast("An error occurred.", error?.message, "error");
    } finally {
      setLoading(false);
      localStorage.removeItem("propt_id");
      setFormData({
       
        prompt: [],
        system_message: [],
        model: "",
        selected_model: "",
        tokens: 1024,
        temperature: 0.3,
        top_p: 0.9,
        json: false,
      });
    }

    setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
      <PopoverTrigger>
        <Button
          bg={"black"}
          color={"white"}
          fontWeight={"bold"}
          size={"sm"}
          onClick={onOpen}
        >
          Save
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverBody>
          <Box>
            <FormControl isRequired>
              <FormLabel fontWeight={500}>Name</FormLabel>
              <Input
                name="name"
                h="45px"
                value={saveFormData.name}
                onChange={handleChange}
                placeholder="Name your Test Prompt"
              />
            </FormControl>
            <FormControl>
              <FormLabel fontWeight={500}>Description</FormLabel>
              <Textarea
                name="desc"
                h="60px"
                value={saveFormData.desc}
                onChange={handleChange}
                placeholder="Write a brief description"
              />
            </FormControl>
            {error && <Text color={"red"}>{error}</Text>}
          </Box>
        </PopoverBody>
        <PopoverFooter display="flex" justifyContent="flex-end">
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmitTestPrompt}
            bgGradient="linear(to-r, rgba(190, 105, 255, 1), rgba(96, 133, 255, 1))"
            _hover={{ bg: "blue.500" }}
          >
            <HStack spacing={2}>
              {loading ? <Spinner /> : <Text color="white">Save</Text>}

              {/* <Image src="/path-to-your-icon.png" alt="Icon" boxSize="18px" /> */}
            </HStack>
          </Button>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  );
};

export default MyPopover;
